import { BridgeInstance } from '../../instance';
import {
  ChangeHistorytoRejectRes,
  HistoryListRes,
  HistoryRes,
  PostHistoryParams,
  PostHistoryRes,
} from './types';

const SUB_URL = `/histories`;

// NOTE: searchParams 쓸까 고민
export const getToChainHistories = async (
  chainSymbol: string,
  sender: string,
  skip: number,
  take: number,
) =>
  BridgeInstance.get<HistoryListRes>(
    `${SUB_URL}/${chainSymbol}/senders/${sender}?skip=${skip}&take=${take}`,
  ).then((res) => res.data);

export const postHistory = (params: PostHistoryParams) =>
  BridgeInstance.post<PostHistoryRes>(`${SUB_URL}`, params).then(
    (res) => res.data,
  );

export const getHistoryById = (id: number) =>
  BridgeInstance.get<HistoryRes>(`${SUB_URL}/${id}`).then((res) => res.data);

// TODO: patch 가 아닌 put. backend 개발자와 상의해 patch로 교체 논의 필요 있음
export const changeHistoryToReject = (id: number) =>
  BridgeInstance.put<ChangeHistorytoRejectRes>(`${SUB_URL}/reject/${id}`).then(
    (res) => res.data,
  );
